import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useEditController } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButton, DeleteButton } from 'shared/mui/Buttons';
import { TextInputIntrospected } from 'shared/react-admin/Inputs';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Company } from 'types/embedded/company';
import { Permission } from 'types/embedded/permission';

import { CompaniesArchiveDialog } from './components/CompaniesArchiveDialog/CompaniesArchiveDialog';
import { CompaniesDeleteDialog } from './components/CompaniesDeleteDialog/CompaniesDeleteDialog';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const transform = ({ createdAt, updatedAt, ...rest }: Company) => rest;

export const CompaniesEdit = () => {
  const translate = useTypedTranslate();
  const { hasResourcePermissions } = usePermissions();
  const { goBack } = useGoBack();
  const { record } = useEditController<Company>();

  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<Company>();

  const {
    handleOpenRecordModal: handleOpenRecordModalArchive,
    openRecordModal: openRecordModalArchive,
    handleCloseRecordModal: handleCloseRecordModalArchive,
  } = useRecordModal<Company>();

  return (
    <>
      <EditGuesserPage
        leftActionsSlot={
          hasResourcePermissions(Resources.Companies, [Permission.Full, Permission.Delete]) ? (
            record?.archive ? (
              <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
            ) : (
              <DeleteButton
                label={translate('app.buttons.inArchive')}
                onClick={() => handleOpenRecordModalArchive()}
                variant="outlined"
              />
            )
          ) : undefined
        }
        listName={translate('app.companies.titleText')}
        mutationOptions={{ onError: () => undefined }}
        open={!openRecordModalDelete && !openRecordModalArchive}
        rightActionsSlot={[
          <CancelButton key="cancel-button" onClick={goBack} variant="outlined" />,
          <SaveButton key="save-button" label={translate('app.buttons.save')} />,
        ]}
        title={translate('app.companies.editTitle')}
        transform={transform}
      >
        <Box py="24px" width="100%">
          <TextInputIntrospected
            fullWidth
            helperText={false}
            label={translate('app.table.name')}
            size="small"
            source="name"
            variant="outlined"
          />
        </Box>
      </EditGuesserPage>
      {openRecordModalDelete && (
        <CompaniesDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        />
      )}
      {openRecordModalArchive && (
        <CompaniesArchiveDialog
          isToRootOnSuccess={true}
          onClose={handleCloseRecordModalArchive}
          open={openRecordModalArchive}
          record={record}
        />
      )}
    </>
  );
};
